module.exports = __webpack_public_path__ + "img/product_13.6cf2d4f.webp";